import {TemplatesWebFrontendRequest} from "services-comun-ed/modules/services/templates/frontend-web";
import {IComponentWindow} from "./interface";
import {Auth} from "../firebase/auth";
import {UserHeaderController} from "./inicio";
import {RestablecerPassPopupController} from "./restablecer-pass";

export class RestablecerPassInfoPopupController {

    /* INSTANCE */
    public static instance: RestablecerPassInfoPopupController;
    private restablecer?: IComponentWindow;

    /* STATIC */
    public static async build(auth: Auth): Promise<RestablecerPassInfoPopupController> {
        return RestablecerPassInfoPopupController.instance = new this(auth);
    }

    private constructor(readonly auth: Auth) {
        TemplatesWebFrontendRequest.loginPopUpRestablecerPasswordInfo().then(async (response) => {
            const restablecer = new DOMParser().parseFromString(response.data, 'text/html').body.firstChild as HTMLElement;
            this.restablecer = {
                window: restablecer,
                buttons: {
                    send_password: restablecer.querySelector("#btn-rt-info") as HTMLButtonElement,
                    close: restablecer.querySelector(".circulo-rt-info") as HTMLButtonElement,
                }
            }
            await this.init();
            document.getElementsByTagName("body").item(0)?.appendChild(this.restablecer!.window);
        });
    }

    private async init(): Promise<void> {
        this.restablecer?.buttons?.send_password?.addEventListener("click", async () => {
            const mainPopup = await RestablecerPassPopupController.instance.getComponent();
            const email = mainPopup.inputs?.email?.value;
            await this.auth.resetPassword(email as string);
        });
        this.restablecer?.buttons?.close?.addEventListener("click", async () => {
            this.restablecer!.window.style.display = "none";
            UserHeaderController.instance.destroyOverlay();
        });
    }

    public async getComponent(): Promise<IComponentWindow> {
        return this.restablecer as IComponentWindow;
    }

}
